import {Injectable} from "@angular/core";
import {HandlerService} from "../comunicator-native/handler/handler";
import {DataOrigin} from "../../model/DataOrigin";
import {CnpjDataService} from "./cnpj-data.service";
import {CnpjDataMobileService} from "./cnpj-data-mobile.service";
import {CnpjMockService} from "./cnpj-data-mock.service";

@Injectable({
    providedIn: 'root'
})
export abstract class CnpjFactoryService {

    private services = new Map<DataOrigin, CnpjDataService>();

    constructor(private handlerService: HandlerService) {}

    public getService(origin: DataOrigin){
      if(this.services.has(origin)){
            return this.services.get(origin);
        }
        else {
            return this.constructService(origin);
        }
    }

    private constructService(origin: DataOrigin): CnpjDataService{
        switch (origin){
            case DataOrigin.Mobile:
                const serviceUserMobile = new CnpjDataMobileService(this.handlerService);
                this.services.set(origin, serviceUserMobile);
                return serviceUserMobile;
            case DataOrigin.Mock:
                const serviceMock = new CnpjMockService();
                this.services.set(origin, serviceMock);
                return serviceMock;
            default:
                const serviceDefault = new CnpjMockService();
                this.services.set(origin, serviceDefault);
                return serviceDefault;
        }

    }

}

